import { CouponTicket } from "@/components/marketing/coupon/CouponTicket"
import { Icon, Price, Text } from "@/components/ui"
import { Gift, Medal, Percent, Star, type IconGlyph } from "@/icons"
import { VARIANTS } from "@/lib/motion"
import { AnimatePresence, motion } from "motion/react"
import { remainingPointsText, type LoyaltySourceKind, type LoyaltySourceRow } from "../../lib/loyalty-source"

const KIND_ICON: Record<LoyaltySourceKind, IconGlyph> = { points: Star, reward: Gift, benefit: Medal, promotion: Percent }

type LoyaltySourceListProps = {
  rows: readonly LoyaltySourceRow[]
}

function detailOf(row: LoyaltySourceRow): string | null {
  const parts = [row.reason, remainingPointsText(row)].filter((part): part is string => Boolean(part))
  return parts.length ? parts.join(" · ") : null
}

/** The order's loyalty discounts as small tickets beside the coupon one: where each comes from, why, the points left, and the amount. */
export function LoyaltySourceList({ rows }: LoyaltySourceListProps) {
  return (
    <ul className="flex flex-col gap-1.5" aria-label="Descontos da fidelidade">
      <AnimatePresence initial={false}>
        {rows.map((row) => {
          const detail = detailOf(row)
          return (
            <motion.li key={row.key} layout="position" variants={VARIANTS.fadeUp} initial="hidden" animate="visible" exit="exit">
              <CouponTicket size="sm" stub={<Icon as={KIND_ICON[row.kind]} size="lg" tone="muted" weight="duotone" />}>
                <div className="min-w-0 py-2 pl-3 pr-3">
                  <div className="flex min-w-0 items-baseline justify-between gap-2">
                    <Text as="span" size="sm" weight="semibold" tone="default" className="min-w-0">
                      {row.label}
                    </Text>
                    <Price value={row.value} sign="minus" size="sm" weight="semibold" tone="success" className="shrink-0" />
                  </div>
                  {detail ? (
                    <Text size="xs" tone="subtle" className="mt-0.5">
                      {detail}
                    </Text>
                  ) : null}
                </div>
              </CouponTicket>
            </motion.li>
          )
        })}
      </AnimatePresence>
    </ul>
  )
}
